/**
 * Dependências externas
 */
import React from 'react';
import { connect as connectToFormik } from 'formik';
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  InputGroup,
  InputRightElement
} from '@chakra-ui/core';

/**
 * Dependênicas internas
 */
import getInformacoesDoCampo from 'utils/form/getInformacoesDoCampo';
import CarregandoInput from 'apresentacao/form/CarregandoInput';

const Complemento = props => {
  const { formik, isLoading, isDisabled, cobranca, ...rest } = props;

  const nomeDoCampo = cobranca ? 'complementoCobranca' : 'complemento';
  const { handleChange, handleBlur } = formik;

  const { valor, erro, possuiErroDeValidacao } = getInformacoesDoCampo(
    props,
    nomeDoCampo
  );

  return (
    <FormControl
      isDisabled={isDisabled}
      isInvalid={possuiErroDeValidacao}
      {...rest}
    >
      <FormLabel htmlFor={nomeDoCampo}>Complemento</FormLabel>
      <InputGroup>
        <Input
          type="text"
          id={nomeDoCampo}
          name={nomeDoCampo}
          onChange={handleChange}
          onBlur={handleBlur}
          value={valor}
          isDisabled={isLoading || isDisabled}
        />

        <InputRightElement>
          {isLoading && <CarregandoInput />}
        </InputRightElement>
      </InputGroup>
      {possuiErroDeValidacao && <FormErrorMessage>{erro}</FormErrorMessage>}
    </FormControl>
  );
};

export default connectToFormik(Complemento);
